var map = {
	"./bg.json": [
		974,
		0
	],
	"./cs.json": [
		975,
		1
	],
	"./da.json": [
		976,
		2
	],
	"./de.json": [
		977,
		3
	],
	"./el.json": [
		978,
		4
	],
	"./en.json": [
		979,
		5
	],
	"./es-ES.json": [
		980,
		6
	],
	"./es-MX.json": [
		981,
		7
	],
	"./fi.json": [
		982,
		8
	],
	"./fr.json": [
		983,
		9
	],
	"./hu.json": [
		984,
		10
	],
	"./it.json": [
		985,
		11
	],
	"./ja.json": [
		986,
		12
	],
	"./ko.json": [
		987,
		13
	],
	"./nb.json": [
		988,
		14
	],
	"./nl.json": [
		989,
		15
	],
	"./pl.json": [
		990,
		16
	],
	"./pt-BR.json": [
		991,
		17
	],
	"./pt-PT.json": [
		992,
		18
	],
	"./ro.json": [
		993,
		19
	],
	"./ru.json": [
		994,
		20
	],
	"./sl.json": [
		995,
		21
	],
	"./sv.json": [
		996,
		22
	],
	"./ta.json": [
		997,
		23
	],
	"./th.json": [
		998,
		24
	],
	"./tr.json": [
		999,
		25
	],
	"./zh-CN.json": [
		1000,
		26
	],
	"./zh-TW.json": [
		1001,
		27
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 966;
module.exports = webpackAsyncContext;